export var ThorchainStatusMessage;
(function (ThorchainStatusMessage) {
    ThorchainStatusMessage["InboundObserved"] = "Inbound transaction accepted by THOR";
    ThorchainStatusMessage["InboundObservingPending"] = "Inbound transaction pending";
    ThorchainStatusMessage["InboundConfirmationCounted"] = "Inbound transaction confirmed";
    ThorchainStatusMessage["InboundConfirmationPending"] = "Awaiting inbound transaction confirmation";
    ThorchainStatusMessage["InboundFinalized"] = "Inbound transaction finalized";
    ThorchainStatusMessage["InboundFinalizationPending"] = "Awaiting inbound transaction finalization";
    ThorchainStatusMessage["SwapPending"] = "Swap pending";
    ThorchainStatusMessage["SwapCompleteAwaitingOutbound"] = "Swap complete, awaiting outbound transaction";
    ThorchainStatusMessage["SwapCompleteAwaitingDestination"] = "Swap complete, awaiting destination chain";
    ThorchainStatusMessage["OutboundDelayTimeRemaining"] = "Awaiting outbound delay ({timeRemaining} remaining)";
    ThorchainStatusMessage["OutboundDelayPending"] = "Awaiting outbound delay";
    ThorchainStatusMessage["OutboundSigned"] = "Outbound transaction transmitted, waiting on destination chain...";
    ThorchainStatusMessage["OutboundScheduled"] = "Outbound transaction scheduled, waiting on destination chain...";
})(ThorchainStatusMessage || (ThorchainStatusMessage = {}));
export var TradeType;
(function (TradeType) {
    TradeType["LongTailToLongTail"] = "LongTailToLongTail";
    TradeType["LongTailToL1"] = "LongTailToL1";
    TradeType["L1ToLongTail"] = "L1ToLongTail";
    TradeType["L1ToL1"] = "L1ToL1";
})(TradeType || (TradeType = {}));
